import { FeaturePermissionDefinition } from "./types"

export type RestrictableFeature =
	| "textFormatterAiOptions"
	| "uniqueLinks"
	| "aiParsingEnabled"
	| "jobDescription"
	| "folders"
	| "fullJobDescription"
	| "placeholderTags"
	| "originalCVEditing"
	| "originalCVHeaders"
	| "customSubdomain"
	| "salesAssets"
	| "showExistingApplications"

export const RESTRICTABLE_FEATURES: { [key in RestrictableFeature]: FeaturePermissionDefinition } = {
	textFormatterAiOptions: {
		label: "Text Formatter AI Options",
		releaseState: "production",
		clientAccessControlled: true,
		userAccessControlled: false,
		defaultClientAccess: true,
		hideToggleOnAdmin: true,
	},
	uniqueLinks: {
		label: "Landing Pages",
		description: "Digital CV",
		releaseState: "production",
		clientAccessControlled: true,
		userAccessControlled: false,
	},
	customSubdomain: {
		label: "Custom Subdomain",
		description: "Set up a custom domain for the client's landing pages",
		releaseState: "production",
		clientAccessControlled: true,
		userAccessControlled: false,
	},
	aiParsingEnabled: {
		label: "AI Parsing",
		releaseState: "production",
		clientAccessControlled: true,
		userAccessControlled: false,
		defaultClientAccess: true,
		hideToggleOnAdmin: true,
	},
	jobDescription: {
		label: "Job Description",
		releaseState: "production",
		clientAccessControlled: true,
		userAccessControlled: false,
		defaultClientAccess: true,
		hideToggleOnAdmin: true,
	},
	folders: {
		label: "Folders",
		releaseState: "production",
		clientAccessControlled: true,
		userAccessControlled: false,
		hideToggleOnAdmin: true,
	},
	fullJobDescription: {
		label: "Job Info (Sift)",
		description: "Show Jobs section and requirements table",
		releaseState: "production",
		clientAccessControlled: true,
		userAccessControlled: false,
	},
	placeholderTags: {
		label: "Placeholder Tags",
		releaseState: "production",
		clientAccessControlled: true,
		userAccessControlled: false,
		defaultClientAccess: true,
		hideToggleOnAdmin: true,
	},
	originalCVEditing: {
		label: "Original CV Editing",
		releaseState: "production",
		clientAccessControlled: false,
		userAccessControlled: false,
	},
	originalCVHeaders: {
		label: "Original CV Headers",
		releaseState: "production",
		clientAccessControlled: false,
		userAccessControlled: false,
	},
	salesAssets: {
		label: "Sales Assets",
		releaseState: "production",
		clientAccessControlled: true,
		userAccessControlled: false,
		defaultClientAccess: false,
		hideToggleOnAdmin: true,
	},
	showExistingApplications: {
		label: "Always Show Uploads",
		description: "Always show existing uploads in integration",
		releaseState: "production",
		clientAccessControlled: true,
		userAccessControlled: false,
	},
}
